import React, { useState } from "react";
import "../css/VideoSidebar.css";
import FavoriteIcon from "@mui/icons-material/Favorite";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import ShareIcon from "@mui/icons-material/Share";
import { useLocation } from "react-router-dom";
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';

function VideoSidebar({ liked, onUnSave, shares, messages, onSave, item }) {
  const location = useLocation();
  const dbName = location.pathname.split('/')[1];
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('success');

  const showNotification = (message, severity = 'success') => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setOpenSnackbar(true);
  };

  const handleShare = async () => {
    try {
      // Basic validation
      if (!item || !item.url) {
        console.error('Share error: Missing item or URL', { item });
        showNotification('Error: Invalid video data', 'error');
        return;
      }

      if (!dbName) {
        console.error('Share error: Missing dbName', { location });
        showNotification('Error: Invalid page data', 'error');
        return;
      }

      // Extract video ID - handle both full URLs and IDs
      let videoId = item.url;
      
      // If it's already just an ID (not a URL), use it as is
      if (!videoId.includes('youtube.com') && !videoId.includes('youtu.be/')) {
        // It's already just an ID
      } else if (videoId.includes('youtube.com')) {
        videoId = videoId.split('v=')[1];
        const ampersandPosition = videoId.indexOf('&');
        if (ampersandPosition !== -1) {
          videoId = videoId.substring(0, ampersandPosition);
        }
      } else if (videoId.includes('youtu.be/')) {
        videoId = videoId.split('youtu.be/')[1];
      }

      // Validate extracted videoId
      if (!videoId) {
        console.error('Share error: Could not extract video ID', { originalUrl: item.url });
        showNotification('Error: Invalid video URL', 'error');
        return;
      }

      // Construct share URL
      const shareUrl = `${window.location.origin}/${dbName}/${videoId}`;
      const shareTitle = `${item.band} at ${item.venue}`;
      const shareText = `Check out ${item.band} playing at ${item.venue}!`;

      console.log('Share Debug:', {
        originalUrl: item.url,
        extractedVideoId: videoId,
        constructedShareUrl: shareUrl,
        shareTitle,
        shareText
      });

      // Try Web Share API first
      if (navigator.share) {
        try {
          await navigator.share({
            title: shareTitle,
            text: shareText,
            url: shareUrl
          });
          showNotification('Successfully shared!');
        } catch (shareError) {
          if (shareError.name === 'AbortError') {
            return; // User cancelled sharing
          }
          // If share API fails, fall back to clipboard
          if (navigator.clipboard) {
            await navigator.clipboard.writeText(shareUrl);
            showNotification('Link copied to clipboard!');
          } else {
            throw new Error('No sharing methods available');
          }
        }
      } else if (navigator.clipboard) {
        // Fallback to clipboard
        await navigator.clipboard.writeText(shareUrl);
        showNotification('Link copied to clipboard!');
      } else {
        throw new Error('No sharing methods available');
      }
    } catch (error) {
      console.error('Share error:', error);
      showNotification(`Failed to share: ${error.message}`, 'error');
    }
  };

  const handleCloseSnackbar = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenSnackbar(false);
  };

  return (
    <div className="videoSidebar">
      <div className="videoSidebar_button">
        {liked ? (
          <FavoriteIcon fontSize="large" onClick={onUnSave} />
        ) : (
          <FavoriteBorderIcon fontSize="large" onClick={onSave} />
        )}
        {/* <p>{liked ? likes + 1 : likes}</p> */}
      </div>
      <div className="videoSidebar_button">
        <ShareIcon fontSize="large" onClick={handleShare} data-testid="ShareIcon" />
      </div>
      <Snackbar 
        open={openSnackbar} 
        autoHideDuration={3000} 
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <MuiAlert 
          elevation={6} 
          variant="filled" 
          onClose={handleCloseSnackbar} 
          severity={snackbarSeverity}
        >
          {snackbarMessage}
        </MuiAlert>
      </Snackbar>
    </div>
  );
}

export default VideoSidebar;
